import React, { useState, useEffect } from "react";
import { useWeightContext } from "../context/appContext";
import RadioInput from "../../../containers/input.radio";
import ContainerWithTitle from "../../../containers/title.container";
import ButtonContainer from "../../../containers/button";

const Questioneleven = ({ onNext, onPrev }) => {
  const { payload, setPayload, currentPage, setCurrentPage, setErrorMessage } =
    useWeightContext();
  const [value, setValue] = useState("");

  useEffect(() => {
    setValue(payload?.eating_habits || "");
  }, [currentPage, payload]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (value) {
      onNext(value);
    } else {
      setErrorMessage("Please select your eating habits.");
    }
  };

  const handleRadioChange = (event) => {
    setErrorMessage(null);
    window.gtag({
      event: "user_eating_habits",
      data: {
        eating_habits: event.target.value,
      },
    });
    if (window.fbq) {
      window.fbq("track", "user_eating_habits", {
        eating_habits: event.target.value,
      });
    }
    setValue(event.target.value);
    onNext(event.target.value);
  };

  return (
    <ContainerWithTitle
      title="Describe your eating habits,"
      handleBack={onPrev}
      isContinueButton={false}
    >
      <div className="radio-container flex lg:flex-row flex-col whitespace-pre">
        <RadioInput
          label="Vegetarian"
          value="Vegetarian"
          colorChecked={value === "Vegetarian"}
          onChange={handleRadioChange}
        />
        <RadioInput
          label="Vegetarian with eggs"
          value="Vegetarian with eggs"
          colorChecked={value === "Vegetarian with eggs"}
          onChange={handleRadioChange}
        />
        <RadioInput
          label="Non-vegetarian"
          value="Non-vegetarian"
          colorChecked={value === "Non-vegetarian"}
          onChange={handleRadioChange}
        />
        <RadioInput
          label="Vegan"
          value="Vegan"
          colorChecked={value === "Vegan"}
          onChange={handleRadioChange}
        />
      </div>
      {/* <ButtonContainer onClick={handleSubmit}>Next</ButtonContainer> */}
    </ContainerWithTitle>
  );
};

export default Questioneleven;
